export type FilterDateTabType = "1d" | "3d" | "7d";

export type DropdownFilterCollectionSelectType = string;

export type FilterCollectionsSelectType = string[];

export const enum FilterStatusType {
  all = "all",
  sale = "sale",
  notSale = "not_sale",
  new = "new",
  participate = "participate",
  participateIn = "participateIn",
  participateEarlier = "participate_earlier",
  my = "my",
  ended = "ended",
  completed = "completed",
  active = "active",
  purchased = "purchased",
}

export const enum TokenTypes {
  TON = "TON",
  RAFF = "RAFF",
  USDT = "USDT",
  ALL = "all",
}

export const enum SortRafffleVolumeTypes {
  totalVolumeRaffleDesc = "total_volume_raffle_desc",
  totalVolumeRaffleAsc = "total_volume_raffle_asc",
  oneDayVolumeRaffleAsc = "one_day_volume_raffle_asc",
  oneDayVolumeRaffleDesc = "one_day_volume_raffle_desc",
  sevenDayVolumeRaffleAsc = "seven_day_volume_raffle_asc",
  sevenDayVolumeRaffleDesc = "seven_day_volume_raffle_desc",
}

export const enum SortSaleVolumeTypes {
  totalVolumeSaleAsc = "total_volume_sale_asc",
  totalVolumeSaleDesc = "total_volume_sale_desc",
  oneDayVolumeSaleAsc = "one_day_volume_sale_asc",
  oneDayVolumeSaleDesc = "one_day_volume_sale_desc",
  sevenDayVolumeSaleAsc = "seven_day_volume_sale_asc",
  sevenDayVolumeSaleDesc = "seven_day_volume_sale_desc",
}

export const enum SortVolumeTypes {
  totalVolumeAsc = "total_volume_asc",
  totalVolumeDesc = "total_volume_desc",
  sevenDayVolumeDesc = "seven_day_volume_desc",
  sevenDayVolumeAsc = "seven_day_volume_asc",
  thirtyDayVolumeDesc = "thirty_day_volume_desc",
  thirtyDayVolumeAsc = "thirty_day_volume_asc",
  oneDayVolumeDesc = "one_day_volume_desc",
  oneDayVolumeAsc = "one_day_volume_asc",
  ONE_DAY_GLOBAL_VOLUME_ASC = "one_day_global_volume_asc",
  ONE_DAY_GLOBAL_VOLUME_DESC = "one_day_global_volume_desc",
  SEVEN_DAY_GLOBAL_VOLUME_ASC = "seven_day_global_volume_asc",
  SEVEN_DAY_GLOBAL_VOLUME_DESC = "seven_day_global_volume_desc",
  THIRTY_DAY_GLOBAL_VOLUME_ASC = "thirty_day_global_volume_asc",
  THIRTY_DAY_GLOBAL_VOLUME_DESC = "thirty_day_global_volume_desc",
  TOTAL_GLOBAL_VOLUME_ASC = "total_global_volume_asc",
  TOTAL_GLOBAL_VOLUME_DESC = "total_global_volume_desc",
}

export const enum SortTypes {
  createdAsc = "created_asc",
  createdDesc = "created_desc",
  endingSoon = "ending_soon",
  priceAsc = "price_asc",
  priceDesc = "price_desc",
  eventAsc = "event_asc",
  eventDesc = "event_desc",
}

export const enum CollectionAddress {
  all = "ALL",
}
